const RELOAD_KEY = 'dd-chunk-reload';

export function isChunkLoadError(error: unknown): boolean {
  const message = toMessage(error);
  return /Failed to fetch dynamically imported module|ChunkLoadError|error loading dynamically imported module|Importing a module script failed/i.test(
    message,
  );
}

export function reloadOnceForChunkError(error: unknown): boolean {
  if (!isChunkLoadError(error) || typeof sessionStorage === 'undefined') {
    return false;
  }

  if (sessionStorage.getItem(RELOAD_KEY) === '1') {
    return false;
  }

  sessionStorage.setItem(RELOAD_KEY, '1');
  window.location.reload();
  return true;
}

function toMessage(error: unknown): string {
  if (error instanceof Error) {
    return `${error.name} ${error.message} ${error.stack ?? ''}`;
  }
  if (typeof error === 'string') {
    return error;
  }
  if (error && typeof error === 'object' && 'message' in error) {
    return String((error as { message: unknown }).message);
  }
  return String(error);
}
